function text(value) {
  return String(value ?? '').trim();
}

function numberOrNull(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function strategyBossDraftSourceKey(bosses = []) {
  return JSON.stringify((Array.isArray(bosses) ? bosses : [])
    .map((boss) => ({
      bossNo: numberOrNull(boss?.bossNo ?? boss?.boss_no),
      bossName: text(boss?.bossName ?? boss?.boss_name ?? boss?.name),
      element: text(boss?.element),
      imageUrl: text(boss?.imageUrl ?? boss?.image_url),
      phases: (Array.isArray(boss?.phases) ? boss.phases : [])
        .map((phase) => ({
          phaseNo: numberOrNull(phase?.phaseNo ?? phase?.phase_no),
          defaultHpEok: numberOrNull(
            phase?.maxHpEok
            ?? phase?.max_hp_eok
            ?? phase?.remainingHpEok
            ?? phase?.remaining_hp_eok,
          ),
        }))
        .sort((left, right) => (left.phaseNo || 0) - (right.phaseNo || 0)),
    }))
    .sort((left, right) => (left.bossNo || 0) - (right.bossNo || 0)));
}
